module.exports = __webpack_public_path__ + "img/yd-zh-img.2cd5e255.png";